import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const IconButton = ({ Icon, containerStyle, onClick }) => {
    const style = `${containerStyle} rounded-md p-2 hover:bg-gray-100`;
    return (_jsx("button", { className: style, onClick: onClick, children: _jsx(FontAwesomeIcon, { className: "cursor-pointer text-gray-600 hover:text-gray-600", icon: Icon, size: "2xl" }) }));
};
export default IconButton;
